import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { DataForDisplayingMenuItemsService } from '../services/data-for-displaying-menu-items.service';
import { ProjectManagerService } from '../services/project-manager.service';
import { InfillTypes } from '../services/railing/infills/model/infill-types';

@Component({
  selector: 'app-edit-railing-height',
  templateUrl: './edit-railing-height.component.html',
  styleUrls: ['./edit-railing-height.component.scss']
})
export class EditRailingHeightComponent implements OnInit {
  height36 = true;
  height38 = true;
  height42 = true;

  railingType = '';
  projectType = '';
  infill = null;
  selectedHeight = {
    height36: false,
    height38: false,
    height42: false
  };
  // Modern kit span sub-menu (spec p.7): 6/8 ft at 36", 6 ft only at 42"
  selectedSpan = '6';

  @Output() step2Editer = new EventEmitter();

  goBack(value) {
    this.step2Editer.emit({ name: value });
  }
  constructor(
    public dataForMenu: DataForDisplayingMenuItemsService,
    public projectSrvc: ProjectManagerService
  ) {
    this.dataForMenu.railingType.subscribe(value => {
      this.railingType = value;
      this.setSelectedSettings(value);
      this.setVisibleContent();
    });

    this.dataForMenu.railingHeight.subscribe(railingHeight =>
      this.setSelectedSettings(railingHeight)
    );

    this.projectSrvc.projectNewChanges.subscribe(value => {
      this.projectType = value;
      this.setVisibleContent();
    });

    this.dataForMenu.infill.subscribe(value => {
      this.infill = value;
      this.setVisibleContent();
    });

    this.dataForMenu.sectionSpan.subscribe(value => {
      this.selectedSpan = value;
    });
  }

  setVisibleContent() {
    if (this.railingType === 'Modern') {
      // Modern kits ship in 36" and 42" heights for any project type
      this.height36 = true;
      this.height38 = false;
      this.height42 = true;
    } else if (this.projectType == 'home' && this.railingType == 'DesignRail') {
      const infillTypesArr = [...Object.values(InfillTypes)];

      const laserCutElements = infillTypesArr.filter(i => i.includes('laserCut'));
      const steelMeshElements = infillTypesArr.filter(i => i.includes('steelMesh'));

      const infillsToHide38 = [...laserCutElements, ...steelMeshElements];

      this.height36 = true;

      // const infillsToHide38 = [
      //   'laserCut',
      //   'laserCutAgama',
      //   'laserCutBound',
      //   'laserCutCubist',
      //   'laserCutPisces',
      //   'laserCutRhythm',
      //   'laserCutSeagrass',
      //   'laserCutSverra',
      //   'laserCutTrillium',
      //   'steelMeshHorizon'
      // ];

      infillsToHide38.includes(this.infill) ? (this.height38 = false) : (this.height38 = true);

      this.height42 = true;
    } else if (this.projectType == 'home' && this.railingType != 'DesignRail') {
      this.height36 = true;
      this.height38 = false;
      this.height42 = true;
    } else {
      this.height36 = false;
      this.height38 = false;
      this.height42 = true;
    }
  }
  setRailingHeight(value: string) {
    this.dataForMenu.setRailingHeight(value);
  }

  setSectionSpan(value: string) {
    this.dataForMenu.setSectionSpan(value);
  }

  setSelectedSettings(value) {
    switch (value) {
      case '36': {
        this.clearSelection();
        this.selectedHeight.height36 = true;
        break;
      }
      case '38': {
        this.clearSelection();
        this.selectedHeight.height38 = true;
        break;
      }
      case '42': {
        this.clearSelection();
        this.selectedHeight.height42 = true;
        break;
      }
    }
  }

  clearSelection() {
    this.selectedHeight = {
      height36: false,
      height38: false,
      height42: false
    };
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/edit-railing-height/edit-railing-height.component.ts